module.exports = __webpack_public_path__ + "static/img/irole.fdd9c21.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/u/irole.png
// module id = V/ne
// module chunks = 7